'use client';

import { FOOTER_TEXT } from 'utils/constants';
import Link from 'next/link';
import React from 'react';
import { SocialMediaLinks } from '../cards/social-media/links';
import { ContactUsCard } from '../cards/contact-us';
import './component.scss';
import LocationWidget from '../location/locationWidget';
import { StickyFooter } from './sticky-footer';
import { StickyFooterData } from '../section/main';
import { PiCaretDownBold } from 'react-icons/pi';

interface FooterProps {
  slug?: string;
  color?: string;
  stickyFooterName?: string;
  data?: StickyFooterData;
}

export const Footer = ({
  slug,
  stickyFooterName: sickyFooterName = 'WhereToBuy',
  data,
}: FooterProps) => {
  function handleToggleFooterSection(
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ): void {
    if (event.target instanceof HTMLElement) {
      const list =
        event.target.parentElement?.parentElement?.querySelector('article');
      const caret = event.target.querySelector('.section-header-icon');
      if (list?.classList.contains('h-0')) {
        list?.classList.remove('h-0');
        caret?.classList.add('rotate-180');
      } else {
        list?.classList.add('h-0');
        caret?.classList.remove('rotate-180');
      }
    }
  }

  return (
    <footer className='relative overflow-hidden bg-white'>
      <div className='mx-auto w-full max-w-[110rem] px-6 pt-16'>
        <div className='flex flex-col gap-y-16 sm:gap-y-20'>
          <div className='grid grid-cols-2 gap-4 sm:grid-cols-4 sm:gap-9'>
            <div className='col-span-4 grid h-full gap-0 pb-4 text-base md:col-span-4 md:grid-cols-6 md:gap-4 md:pb-0 md:text-sm lg:col-span-3'>
              <div className='collapse flex flex-col'>
                <section className='relative w-full border-b py-2 text-neutral-500 md:border-none md:pb-3'>
                  <div className='md:hidden'>
                    <button
                      onClick={handleToggleFooterSection}
                      className='flex w-full justify-between border-t border-white pb-4 text-left font-bold text-gray-950 focus:outline-none'
                      type='button'
                    >
                      Ductless Mini-Splits
                      <PiCaretDownBold className='section-header-icon transition-all duration-300' />
                    </button>
                  </div>
                  <span className='hidden cursor-default font-bold text-gray-950 md:block'>
                    Ductless Mini-Splits
                  </span>
                  <article className='-mt-4 h-0 overflow-hidden md:mt-0 md:h-auto'>
                    <ul className='my-2'>
                      <li className='my-2'>
                        <Link
                          className='transition-colors duration-200 hover:text-gray-900'
                          href={{ pathname: '/product/diy-5th-generation' }}
                        >
                          5th Gen DIY&reg;
                        </Link>
                      </li>
                      <li className='my-2'>
                        <Link
                          className='transition-colors duration-200 hover:text-gray-900'
                          href={{ pathname: '/product/easy-pro' }}
                        >
                          Easy Pro
                        </Link>
                      </li>
                      <li className='my-2'>
                        <Link
                          className='transition-colors duration-200 hover:text-gray-900'
                          href={{ pathname: '/product/diy-ceiling-cassette' }}
                        >
                          DIY&reg; OuttaSight&trade; Ceiling Cassette
                        </Link>
                      </li>
                      <li className='my-2'>
                        <Link
                          className='transition-colors duration-200 hover:text-gray-900'
                          href={{ pathname: '/product/advantage-3rd-gen' }}
                        >
                          Advantage
                        </Link>
                      </li>
                      <li className='my-2'>
                        <Link
                          className='transition-colors duration-200 hover:text-gray-900'
                          href={{ pathname: '/product/olympus-e-star' }}
                        >
                          Olympus E Star
                        </Link>
                      </li>
                      <li className='my-2'>
                        <Link
                          className='transition-colors duration-200 hover:text-gray-900'
                          href={{ pathname: '/product/olympus-hyper-heat' }}
                        >
                          Olympus Hyper Heat
                        </Link>
                      </li>
                      <li className='my-2'>
                        <Link
                          className='transition-colors duration-200 hover:text-gray-900'
                          href={{ pathname: '/product/olympus-multi-zone' }}
                        >
                          Olympus Multi Zone
                        </Link>
                      </li>
                    </ul>
                  </article>
                </section>
              </div>
              <div className='flex flex-col'>
                <section className='relative w-full border-b py-2 text-neutral-500 md:border-none md:pb-3'>
                  <div className='md:hidden'>
                    <button
                      onClick={handleToggleFooterSection}
                      className='flex w-full justify-between border-t border-white pb-4 text-left font-bold text-gray-950 focus:outline-none'
                      type='button'
                    >
                      Universal&reg;
                      <PiCaretDownBold className='section-header-icon transition-all duration-300' />
                    </button>
                  </div>
                  <span className='hidden cursor-default font-bold text-gray-950 md:block'>
                    Universal&reg;
                  </span>
                  <article className='-mt-4 h-0 max-h-full overflow-hidden md:mt-0 md:h-auto'>
                    <ul className='my-2'>
                      <li className='my-2'>
                        <Link
                          className='transition-colors duration-200 hover:text-gray-900'
                          href={{ pathname: '/product/geo-cool-inverter' }}
                        >
                          Universal&reg; Series
                        </Link>
                      </li>
                    </ul>
                  </article>
                </section>
                <section className='relative w-full border-b py-2 text-neutral-500 md:border-none md:pb-3'>
                  <div className='md:hidden'>
                    <button
                      onClick={handleToggleFooterSection}
                      className='flex w-full justify-between border-t border-white pb-4 text-left font-bold text-gray-950 focus:outline-none'
                      type='button'
                    >
                      GeoCool&reg;
                      <PiCaretDownBold className='section-header-icon transition-all duration-300' />
                    </button>
                  </div>
                  <span className='hidden cursor-default font-bold text-gray-950 md:block'>
                    GeoCool&reg;
                  </span>
                  <article className='-mt-4 h-0 max-h-full overflow-hidden md:mt-0 md:h-auto'>
                    <ul className='my-2'>
                      <li className='my-2'>
                        <Link
                          className='transition-colors duration-200 hover:text-gray-900'
                          href={{ pathname: '/product/geo-cool-inverter' }}
                        >
                          GeoCool&reg; Inverter Series
                        </Link>
                      </li>
                    </ul>
                  </article>
                </section>
                <section className='relative w-full border-b py-2 text-neutral-500 md:border-none md:pb-3'>
                  <div className='md:hidden'>
                    <button
                      onClick={handleToggleFooterSection}
                      className='flex w-full justify-between border-t border-white pb-4 text-left font-bold text-gray-950 focus:outline-none'
                      type='button'
                    >
                      Central Package Unit
                      <PiCaretDownBold className='section-header-icon transition-all duration-300' />
                    </button>
                  </div>
                  <span className='hidden cursor-default font-bold text-gray-950 md:block'>
                    Central Package Unit
                  </span>
                  <article className='-mt-4 h-0 max-h-full overflow-hidden md:mt-0 md:h-auto'>
                    <ul className='my-2'>
                      <li className='my-2'>
                        <Link
                          className='transition-colors duration-200 hover:text-gray-900'
                          href={{
                            pathname: '/product/universal-package-heat-pump',
                          }}
                        >
                          Universal&reg; Package Heat Pump
                        </Link>
                      </li>
                      <li className='my-2'>
                        <Link
                          className='transition-colors duration-200 hover:text-gray-900'
                          href={{
                            pathname:
                              '/product/mrcool-signature-series-package-gas-electric-mpg14',
                          }}
                        >
                          Package Gas &amp; Electric
                        </Link>
                      </li>
                      <li className='my-2'>
                        <Link
                          className='transition-colors duration-200 hover:text-gray-900'
                          href={{
                            pathname:
                              '/product/mrcool-signature-series-package-ac-mpc14',
                          }}
                        >
                          Package A/C
                        </Link>
                      </li>
                      <li className='my-2'>
                        <Link
                          className='transition-colors duration-200 hover:text-gray-900'
                          href={{
                            pathname:
                              '/product/mrcool-signature-series-package-heat-pump-mph14',
                          }}
                        >
                          Package Heat Pump
                        </Link>
                      </li>
                    </ul>
                  </article>
                </section>
              </div>
              <div className='flex flex-col'>
                <section className='relative w-full border-b py-2 text-neutral-500 md:border-none md:pb-3'>
                  <div className='md:hidden'>
                    <button
                      onClick={handleToggleFooterSection}
                      className='flex w-full justify-between border-t border-white pb-4 text-left font-bold text-gray-950 focus:outline-none'
                      type='button'
                    >
                      Central Split System
                      <PiCaretDownBold className='section-header-icon transition-all duration-300' />
                    </button>
                  </div>
                  <span className='hidden cursor-default font-bold text-gray-950 md:block'>
                    Central Split System
                  </span>
                  <article className='-mt-4 h-0 max-h-full overflow-hidden md:mt-0 md:h-auto'>
                    <ul className='my-2'>
                      <li className='my-2'>
                        <Link
                          className='transition-colors duration-200 hover:text-gray-900'
                          href={{
                            pathname: '/product/central-ducted',
                          }}
                        >
                          Central Ducted Hyper Heat
                        </Link>
                      </li>
                      <li className='my-2'>
                        <Link
                          className='transition-colors duration-200 hover:text-gray-900'
                          href={{
                            pathname: '/product/versapro',
                          }}
                        >
                          MRCOOL&reg; Central Ducted VersaPro&trade;
                        </Link>
                      </li>
                      <li className='my-2'>
                        <Link
                          className='transition-colors duration-200 hover:text-gray-900'
                          href={{
                            pathname: '/product/prodirect-series',
                          }}
                        >
                          ProDirect&trade; Series
                        </Link>
                      </li>
                      <li className='my-2'>
                        <Link
                          className='transition-colors duration-200 hover:text-gray-900'
                          href={{
                            pathname: '/product/ac-condensers-mac16',
                          }}
                        >
                          A/C Condensers
                        </Link>
                      </li>
                      <li className='my-2'>
                        <Link
                          className='transition-colors duration-200 hover:text-gray-900'
                          href={{
                            pathname: '/product/heat-pump-condensers-mhp15',
                          }}
                        >
                          Heat Pump Condensers
                        </Link>
                      </li>
                      <li className='my-2'>
                        <Link
                          className='transition-colors duration-200 hover:text-gray-900'
                          href={{
                            pathname: '/product/80-gas-furnaces',
                          }}
                        >
                          80% Gas Furnaces
                        </Link>
                      </li>
                      <li className='my-2'>
                        <Link
                          className='transition-colors duration-200 hover:text-gray-900'
                          href={{
                            pathname: '/product/95-gas-furnaces',
                          }}
                        >
                          95% Gas Furnaces
                        </Link>
                      </li>
                      <li className='my-2'>
                        <Link
                          className='transition-colors duration-200 hover:text-gray-900'
                          href={{
                            pathname: '/product/96-gas-furnaces',
                          }}
                        >
                          96% Gas Furnaces
                        </Link>
                      </li>
                      <li className='my-2'>
                        <Link
                          className='transition-colors duration-200 hover:text-gray-900'
                          href={{
                            pathname:
                              '/product/mrcool-signature-series-coils-mcvp-mchp-mcdp',
                          }}
                        >
                          Evaporator Coils
                        </Link>
                      </li>
                      <li className='my-2'>
                        <Link
                          className='transition-colors duration-200 hover:text-gray-900'
                          href={{
                            pathname: '/product/modular-blowers',
                          }}
                        >
                          Modular Blowers
                        </Link>
                      </li>
                    </ul>
                  </article>
                </section>
              </div>
              <div className='flex flex-col'>
                <section className='relative w-full border-b py-2 text-neutral-500 md:border-none md:pb-3'>
                  <div className='md:hidden'>
                    <button
                      onClick={handleToggleFooterSection}
                      className='flex w-full justify-between border-t border-white pb-4 text-left font-bold text-gray-950 focus:outline-none'
                      type='button'
                    >
                      Fan Solution
                      <PiCaretDownBold className='section-header-icon transition-all duration-300' />
                    </button>
                  </div>
                  <span className='hidden cursor-default font-bold text-gray-950 md:block'>
                    Fan Solution
                  </span>
                  <article className='-mt-4 h-0 max-h-full overflow-hidden md:mt-0 md:h-auto'>
                    <ul className='my-2'>
                      <li className='my-2'>
                        <Link
                          className='transition-colors duration-200 hover:text-gray-900'
                          href={{
                            pathname: '/product/mrbreeze',
                          }}
                        >
                          MRBREEZE&trade; Bladeless Fan
                        </Link>
                      </li>
                      <li className='my-2'>
                        <Link
                          className='transition-colors duration-200 hover:text-gray-900'
                          href={{
                            pathname: '/product/cool-blade',
                          }}
                        >
                          CoolBlade&trade; HVLS Fan
                        </Link>
                      </li>
                    </ul>
                  </article>
                </section>
                <section className='relative w-full border-b py-2 text-neutral-500 md:border-none md:pb-3'>
                  <div className='md:hidden'>
                    <button
                      onClick={handleToggleFooterSection}
                      className='flex w-full justify-between border-t border-white pb-4 text-left font-bold text-gray-950 focus:outline-none'
                      type='button'
                    >
                      Thermostats
                      <PiCaretDownBold className='section-header-icon transition-all duration-300' />
                    </button>
                  </div>
                  <span className='hidden cursor-default font-bold text-gray-950 md:block'>
                    Thermostats
                  </span>
                  <article className='-mt-4 h-0 max-h-full overflow-hidden md:mt-0 md:h-auto'>
                    <ul className='my-2'>
                      <li className='my-2'>
                        <Link
                          className='transition-colors duration-200 hover:text-gray-900'
                          href={{
                            pathname: '/product/mrcool-mini-stat',
                          }}
                        >
                          MRCOOL&reg; Mini-Stat
                        </Link>
                      </li>
                      <li className='my-2'>
                        <Link
                          className='transition-colors duration-200 hover:text-gray-900'
                          href={{
                            pathname: '/product/smart-thermostat',
                          }}
                        >
                          MRCOOL&reg; Smart Thermostat
                        </Link>
                      </li>
                    </ul>
                  </article>
                </section>
              </div>
              <div className='flex flex-col'>
                <section className='relative w-full border-b py-2 text-neutral-500 md:border-none md:pb-3'>
                  <div className='md:hidden'>
                    <button
                      onClick={handleToggleFooterSection}
                      className='flex w-full justify-between border-t border-white pb-4 text-left font-bold text-gray-950 focus:outline-none'
                      type='button'
                    >
                      About MRCOOL
                      <PiCaretDownBold className='section-header-icon transition-all duration-300' />
                    </button>
                  </div>
                  <span className='hidden cursor-default font-bold text-gray-950 md:block'>
                    About MRCOOL
                  </span>
                  <article className='-mt-4 h-0 max-h-full overflow-hidden md:mt-0 md:h-auto'>
                    <ul className='my-2'>
                      <li className='my-2'>
                        <Link
                          className='transition-colors duration-200 hover:text-gray-900'
                          href={{
                            pathname: '/support/our-story',
                          }}
                        >
                          Our Story
                        </Link>
                      </li>
                      <li className='my-2'>
                        <Link
                          className='transition-colors duration-200 hover:text-gray-900'
                          href={{
                            pathname:
                              'https://support.mrcool.com/hc/en-us/requests/new',
                          }}
                        >
                          Contact Us
                        </Link>
                      </li>
                      <li className='my-2'>
                        <Link
                          className='transition-colors duration-200 hover:text-gray-900'
                          href={{
                            pathname: '/locations',
                          }}
                        >
                          Locations
                        </Link>
                      </li>
                      <li className='my-2'>
                        <Link
                          className='transition-colors duration-200 hover:text-gray-900'
                          href={{
                            pathname: '/blog',
                          }}
                        >
                          Blog
                        </Link>
                      </li>
                      <li className='my-2'>
                        <Link
                          className='transition-colors duration-200 hover:text-gray-900'
                          href={{
                            pathname: '/intelectual-property/patents',
                          }}
                        >
                          Patents
                        </Link>
                      </li>
                      <li className='my-2'>
                        <Link
                          className='transition-colors duration-200 hover:text-gray-900'
                          href={{
                            pathname: '/intelectual-property/trademarks',
                          }}
                        >
                          Trademarks
                        </Link>
                      </li>
                      <li className='my-2'>
                        <Link
                          className='transition-colors duration-200 hover:text-gray-900'
                          href={{
                            pathname: '/system-selector',
                          }}
                        >
                          System Selector <sup>Beta</sup>
                        </Link>
                      </li>
                    </ul>
                  </article>
                </section>
              </div>
              <div className='flex flex-col'>
                <section className='relative w-full border-b py-2 text-neutral-500 md:border-none md:pb-3'>
                  <div className='md:hidden'>
                    <button
                      onClick={handleToggleFooterSection}
                      className='flex w-full justify-between border-t border-white pb-4 text-left font-bold text-gray-950 focus:outline-none'
                      type='button'
                    >
                      Support
                      <PiCaretDownBold className='section-header-icon transition-all duration-300' />
                    </button>
                  </div>
                  <span className='hidden cursor-default font-bold text-gray-950 md:block'>
                    Support
                  </span>
                  <article className='-mt-4 h-0 max-h-full overflow-hidden md:mt-0 md:h-auto'>
                    <ul className='my-2'>
                      <li className='my-2'>
                        <Link
                          className='transition-colors duration-200 hover:text-gray-900'
                          href={{
                            pathname: 'https://support.mrcool.com/hc/en-us',
                          }}
                          target='_blank'
                        >
                          Support
                        </Link>
                      </li>
                      <li className='my-2'>
                        <Link
                          className='transition-colors duration-200 hover:text-gray-900'
                          href={{
                            pathname: '/support/dealer-signup',
                          }}
                        >
                          Become a Dealer
                        </Link>
                      </li>
                      <li className='my-2'>
                        <Link
                          className='transition-colors duration-200 hover:text-gray-900'
                          href={{
                            pathname: '/support/become-influencer',
                          }}
                        >
                          Become an Influencer
                        </Link>
                      </li>
                      <li className='my-2'>
                        <Link
                          className='transition-colors duration-200 hover:text-gray-900'
                          href={{
                            pathname: '/rebates',
                          }}
                        >
                          Rebate Center
                        </Link>
                      </li>
                      <li className='my-2'>
                        <Link
                          className='transition-colors duration-200 hover:text-gray-900'
                          href={{
                            pathname: '/warranty-information',
                          }}
                        >
                          Warranty Information
                        </Link>
                      </li>
                      <li className='my-2'>
                        <Link
                          className='transition-colors duration-200 hover:text-gray-900'
                          href={{
                            pathname: '/warranty-registration',
                          }}
                        >
                          Warranty Registration
                        </Link>
                      </li>
                      <li className='my-2'>
                        <Link
                          className='transition-colors duration-200 hover:text-gray-900'
                          href={{
                            pathname: 'https://portal.mrcool.com/',
                          }}
                          target='_blank'
                        >
                          Partner Center
                        </Link>
                      </li>
                    </ul>
                  </article>
                </section>
              </div>
            </div>
            <div className='col-span-4 flex flex-col gap-y-2 md:col-span-4 lg:hidden'>
              <Link
                href={{ pathname: '/' }}
                scroll={true}
                className='flex justify-center md:justify-start'
              >
                <img
                  src='/images/mrcool-logo.svg'
                  alt='logo'
                  className='w-full max-w-40'
                />
              </Link>

              <div className='mx-auto my-4 md:mx-0'>
                <LocationWidget mobileView={true} ignoreTheme={true} />
              </div>
            </div>
            <ContactUsCard classNames='col-span-4 md:col-span-2 lg:col-span-1' />
          </div>

          <div className='flex flex-col gap-y-6'>
            <div className='flex flex-col lg:flex-row lg:items-center lg:justify-between'>
              <Link
                href={{ pathname: '/' }}
                scroll={true}
                className='hidden flex-none lg:block'
              >
                <img
                  src='/images/mrcool-logo.svg'
                  alt='logo'
                  className='w-full max-w-40'
                />
              </Link>

              <div className='mt-9 hidden sm:ml-9 sm:mt-0 lg:block'>
                <LocationWidget ignoreTheme={true} />
              </div>

              <div className='mt-9 flex items-center justify-center gap-2 sm:mt-0 lg:w-full lg:justify-end'>
                <div className='grid grid-cols-6 gap-3'>
                  <SocialMediaLinks classNames='social-footer mrc-social-links' />
                </div>
              </div>
            </div>
            <div className='pb-12  pt-6'>
              <div className='flex flex-col-reverse lg:flex-row lg:items-center lg:justify-between'>
                <div className=' text-center text-sm text-gray-600 dark:text-gray-400'>
                  {FOOTER_TEXT.copyright}
                </div>

                <div className='mb-5 flex justify-center gap-4 text-sm sm:gap-8 md:justify-start lg:mb-0'>
                  <Link
                    className='text-center text-sm text-gray-600 hover:text-gray-800 dark:text-gray-400 dark:hover:text-gray-200 dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600 sm:inline-flex'
                    href={{ pathname: '/privacy-policy' }}
                  >
                    {FOOTER_TEXT.privacyPolicy}
                  </Link>
                  <Link
                    className='text-center text-sm text-gray-600 hover:text-gray-800 dark:text-gray-400 dark:hover:text-gray-200 dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600 sm:inline-flex'
                    href={{ pathname: '/terms-and-conditions' }}
                  >
                    {FOOTER_TEXT.termsAndConditions}
                  </Link>
                  <Link
                    className='text-center text-sm text-gray-600 hover:text-gray-800 dark:text-gray-400 dark:hover:text-gray-200 dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600 sm:inline-flex'
                    href={{ pathname: '/warranty-disclaimer' }}
                  >
                    Warranty Disclaimer
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {slug && <StickyFooter name={sickyFooterName} slug={slug} data={data} />}
    </footer>
  );
};

export default Footer;
